import { prepareSearchParams } from "@/libs/helper";
import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";

const resource = `${Config.basePath}/report`;

export default {
  index(payload) {
    return Client.get(`${resource}/call/overview`, {
      params: prepareSearchParams(payload),
    });
  },
};
